import { useApi } from '../instance';
import { UserInfo } from '@games/types';
import { clearUserInfo } from './utils';

export const useLogin = () => {
  return useApi<UserInfo, { username: string; password: string }>(
    {
      url: 'auth/login',
      method: 'POST',
    },
    { manual: true },
  );
};

export const useRegister = () => {
  return useApi<
    UserInfo | { error: string },
    { username: string; password: string; email: string }
  >(
    {
      url: 'auth/register',
      method: 'POST',
    },
    { manual: true },
  );
};

export const useChangePassword = () => {
  return useApi<
    { success: boolean },
    { oldPassword: string; newPassword: string }
  >(
    {
      url: 'auth/change-password',
      method: 'POST',
    },
    { manual: true },
  );
};

export const useSetPrefs = () => {
  return useApi<{ success: boolean }, { lang?: string; nonogramSize?: number }>(
    {
      url: 'auth/set-prefs',
      method: 'POST',
    },
    { manual: true },
  );
};

export const useLogout = (): [null, () => void] => {
  return [
    null,
    clearUserInfo,
  ];
};

export const useUserInfo = () => {
  return useApi<UserInfo>(
    {
      url: 'auth/user-info',
      method: 'GET',
    }
  );
};
